import { render, staticRenderFns } from "./Bankkbank.vue?vue&type=template&id=2c825f7b&"
import script from "./Bankkbank.vue?vue&type=script&lang=js&"
export * from "./Bankkbank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports